/** Base para errores reconocibles del dominio catálogo (UI puede mapear por `code`). */
export class CatalogDomainError extends Error {
  readonly code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = new.target.name;
    this.code = code;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class CatalogSkuDuplicateError extends CatalogDomainError {
  constructor(message = 'Ya existe un producto con ese SKU.') {
    super('CATALOG_SKU_DUPLICATE', message);
  }
}

export class CatalogBarcodeDuplicateError extends CatalogDomainError {
  constructor(message = 'Ya existe un producto con ese código de barras.') {
    super('CATALOG_BARCODE_DUPLICATE', message);
  }
}

/**
 * Código de proveedor duplicado dentro de la org. Espeja el unique index
 * `uq_suppliers_org_code_alive` (organization_id, lower(trim(code))) WHERE deleted_at IS NULL.
 * Se lanza pre-validando contra el snapshot RAM antes de submitir, y como fallback
 * cuando el backend rechaza con duplicate key (snapshot desactualizado).
 */
export class SupplierCodeDuplicateError extends CatalogDomainError {
  constructor(message = 'Ya existe un proveedor con ese código. Elegí otro o editá el existente.') {
    super('SUPPLIER_CODE_DUPLICATE', message);
  }
}

/**
 * Nombre de marca duplicado dentro de la org (case-insensitive, trim).
 * Antes `createBrand` devolvía el id existente en silencio — la UI cerraba el
 * modal como si hubiera creado la marca. Ahora se muestra inline y no se cierra.
 */
export class BrandNameDuplicateError extends CatalogDomainError {
  constructor(message = 'Ya existe una marca con ese nombre') {
    super('BRAND_NAME_DUPLICATE', message);
  }
}

/**
 * Validación de input de variante (sufijo/SKU/atributo/barcode).
 * Es un error esperado de validación, no un fallo inesperado — no debe llegar a Sentry.
 * VUELTO-NEGOCIO-23: antes se reportaba como error inesperado porque usaba `throw new Error`.
 */
export class VariantInputValidationError extends CatalogDomainError {
  constructor(message: string) {
    super('VARIANT_INPUT_INVALID', message);
  }
}
